var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: { "has-error": _vm.validationErrors.has(_vm.validationId) },
      attrs: { "data-validation-id": _vm.validationId }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._t("validation-message", function() {
        return [
          _vm.validationErrors.has(_vm.validationId)
            ? _c("validation-message", {
                staticClass: "help-block",
                attrs: {
                  "validation-id": _vm.validationId,
                  "validation-errors": _vm.validationErrors
                }
              })
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }